import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetProfile } from "../redux/slices/GetProfileSlice";
import { FaUser } from "react-icons/fa";

const Profile = () => {
  const dispatch = useDispatch();
  const [profilePic, setProfilePic] = useState(
    "https://randomuser.me/api/portraits/men/32.jpg"
  );
  const { GetProfileData } = useSelector((state) => state?.getProfileData);

  useEffect(() => {
    dispatch(GetProfile());
  }, [dispatch]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-indigo-300 via-gray-300 to-white-400">
      <div className="bg-white/40 backdrop-blur-md rounded-2xl shadow-xl p-6 w-full max-w-lg space-y-8 border border-white/30 sm:m-0 m-3">
        <div className="flex justify-center">
          <div className="w-24 h-24 rounded-full border-4 border-white/50 bg-gray-200 flex items-center justify-center transform transition duration-300 hover:scale-110">
            <FaUser className="text-gray-500 text-6xl" />
          </div>
        </div>

        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <label className="text-gray-700 text-sm font-medium">
              Full Name:
            </label>
            <p className="text-lg text-gray-900">
              {GetProfileData?.user?.name}
            </p>
          </div>

          <div className="flex justify-between items-center">
            <label className="text-gray-700 text-sm font-medium">Email:</label>
            <p className="text-lg text-gray-900">
              {GetProfileData?.user?.email}
            </p>
          </div>
        </div>

        {/* <div className="flex justify-center mt-8">
          <button
            onClick={handleEdit}
            className="px-6 py-3 bg-indigo-600 text-white rounded-lg shadow-md transform transition duration-300 hover:bg-indigo-700 hover:scale-105 focus:outline-none"
          >
            Edit Profile
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Profile;
